import { find, get } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useAllBook } from 'store/books/selectors';
import { useBookUnits } from 'store/booksUnits/selectors';
import { ebookConfigDinamic } from 'utils/lib/ebookHelper';

export const useGetMaskId = (from, page, chapter) => {
  const bookUnitList = useBookUnits();
  const BALCON_PAGES = get(find(bookUnitList, ['bookId', chapter]), 'pages', []);
  const booksAllList = useAllBook();
  const data = ebookConfigDinamic(chapter, booksAllList);

  const maskId = useMemo(() => {
    if (!page && !from && !chapter) return null;
    if (from === 'balcon' && BALCON_PAGES?.length > 0) {
      const balconPage = BALCON_PAGES.find((p) => {
        const startNum = parseInt(p.start, 10);
        const finishNum = parseInt(p.finish, 10);
        const pageNum = parseInt(page, 10);
        return startNum <= pageNum && finishNum >= pageNum;
      });
      if (balconPage) {
        const pageNum = parseInt(page, 10);
        const startNum = parseInt(balconPage.start, 10);
        const pageResult = pageNum - startNum + 1;
        return `${pageResult}`;
      }
      return page;
    } else {
      const maskId = get(
        find(get(data, 'content'), (k) => k.pageId == page),
        'numberMasked',
        page,
      );
      return maskId;
    }
  }, [from, BALCON_PAGES, data, page]);


  const generateMaskId = (page, bookId) => {
    if (!page && !bookId) return null;
    const dataList = ebookConfigDinamic(bookId, booksAllList);
    const balconPages = get(find(bookUnitList, ['bookId', bookId]), 'pages', []);
    if (from === 'balcon' && balconPages?.length > 0) {
      const balconPage = balconPages.find((p) => {
        const startNum = parseInt(p.start, 10);
        const finishNum = parseInt(p.finish, 10);
        const pageNum = parseInt(page, 10);
        return startNum <= pageNum && finishNum >= pageNum;
      });
      if (balconPage) {
        const pageNum = parseInt(page, 10);
        const startNum = parseInt(balconPage.start, 10);
        const pageResult = pageNum - startNum + 1;
        return `${pageResult}`;
      }
      return page;
    }
    else{
      const maskId = get(
        find(get(dataList, 'content'), (k) => k.pageId == page),
        'numberMasked',
        page,
      );
      return maskId;
    }
   
  };

  return {
    maskId,
    generateMaskId
  };
};
